import React from "react"

type AnyProps = Record<string, unknown>

export default function MuxPlayerClient(props: AnyProps) {
  const [MuxPlayer, setMuxPlayer] =
    React.useState<null | React.ComponentType<AnyProps>>(null)

  React.useEffect(() => {
    let mounted = true
    if (typeof window !== "undefined") {
      import("@mux/mux-player-react")
        .then((mod) => {
          if (mounted) {
            // v2 exports named MuxPlayer
            setMuxPlayer(
              () => (mod as any).MuxPlayer || (mod as any).default || null
            )
          }
        })
        .catch(() => {
          if (mounted) {
            setMuxPlayer(null)
          }
        })
    }
    return () => {
      mounted = false
    }
  }, [])

  if (!MuxPlayer) {
    return null
  }

  return <MuxPlayer {...props} />
}
